import { useContext, useState } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";
import ConfirmationPopup from "../../../Components/ConfirmationPopup/ConfirmationPopup";
import { createPortal } from "react-dom";
import { AnimatePresence } from "framer-motion";

const ChangeSignature = () => {
  const { userData, setUserData, route, displayAuthenticationError } =
    useContext(AppContext);
  const [displayChangeSignaturePopup, setDisplayChangeSignaturePopup] =
    useState(false);
  const [userSignature, setUserSignature] = useState(
    userData.UserSignature || ""
  );

  const fetchUserSignatureChange = async () => {
    return await fetch(`${route}/sendusersignature.webapi`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Token: userData.Token,
      },
      body: JSON.stringify({
        customerId: userData.CustomerId,
        CustomerSignature: userSignature,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error();
        }
      })
      .then(() => {
        let tempUserData = structuredClone(userData);
        tempUserData.UserSignature = userSignature;
        setUserData(tempUserData);
        return true;
      })
      .catch((error) => {
        window.alert("Unable to submit your signature. Please try again.");
        return false;
      });
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Your Signature</h3>
      <p className="accountSettingsToggleDescription">
        During the exam, you are required to write a letter and sign it with
        your name with or without a title. Your signature is currently{" "}
        <strong>{userData.UserSignature}</strong>
      </p>
      <button
        className="accountSettingsButton"
        onClick={() => setDisplayChangeSignaturePopup(true)}
      >
        Change Signature
      </button>
      {displayChangeSignaturePopup &&
        createPortal(
          <AnimatePresence mode="wait">
            <ConfirmationPopup
              title={`Change Your Signature`}
              description={`During the exam, you are required to write a letter and sign it with your name with or without a title. Please enter how you will be signing your letter (i.e. Dr. George Smith or Dr. George Smith, MD).`}
              confirmFunction={fetchUserSignatureChange}
              key={"ConfirmationPopup"}
              closePopup={() => setDisplayChangeSignaturePopup(false)}
            >
              <div className="printReceiptInputContainer">
                <input
                  className="standardInput"
                  id="changeSignatureInput"
                  type="text"
                  placeholder="Test User"
                  onChange={(e) => setUserSignature(e.target.value)}
                  value={userSignature}
                />
              </div>
            </ConfirmationPopup>
          </AnimatePresence>,
          document.body
        )}
    </div>
  );
};

export default ChangeSignature;
